import classNames from "classnames";

import { HOME_PATH } from "./constants";
import { BreadcrumbItemType } from "./types";
import BreadcrumbContainer from "./BreadcrumbContainer";
import BreadcrumbItem from "./BreadcrumbItem";

interface Props {
  breadcrumbs: BreadcrumbItemType[];
  translate: (key: string) => string;
  withoutLink?: boolean;
  suffix?: React.ReactNode;
  customLabel?: string;
  containerClassName?: string;
  itemClassName?: string;
  isFullWidtContainer?: boolean;
}

const BreadcrumbContent: React.FC<Props> = ({
  breadcrumbs,
  translate,
  withoutLink,
  suffix,
  customLabel,
  containerClassName,
  itemClassName,
  isFullWidtContainer,
}) => {
  return (
    <BreadcrumbContainer
      suffix={suffix}
      className={classNames(
        "py-4 bg-white border-b border-[#e1e4e8]",
        containerClassName
      )}
      isFullWidth={isFullWidtContainer}
    >
      <BreadcrumbItem href={HOME_PATH} className={itemClassName}>
        {translate("home")}
      </BreadcrumbItem>

      {breadcrumbs.map((breadcrumb, index) => (
        <BreadcrumbItem
          key={breadcrumb.href}
          href={breadcrumb.href}
          withoutLink={withoutLink}
          className="flex items-center overflow-auto no-scrollbar h-full"
        >
          {customLabel
            ? index + 1 === breadcrumbs.length
              ? customLabel
              : breadcrumb.label
            : breadcrumb.label}
        </BreadcrumbItem>
      ))}
    </BreadcrumbContainer>
  );
};

export default BreadcrumbContent;
